export default __webpack_public_path__ + "static/media/mariadb.7a4ae6e0.svg";